import { render, staticRenderFns } from "./card_packet_desc_info.vue?vue&type=template&id=dce0b3ee&scoped=true&"
import script from "./card_packet_desc_info.vue?vue&type=script&lang=js&"
export * from "./card_packet_desc_info.vue?vue&type=script&lang=js&"
import style0 from "./card_packet_desc_info.vue?vue&type=style&index=0&id=dce0b3ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce0b3ee",
  null
  
)

export default component.exports